module.exports = __webpack_public_path__ + "static/media/mosk-light-300-webfont.67f521c7.woff2";